import { useEffect } from 'react';

export const IMPORT_COMPLETE_EVENT = 'endchess:import-complete';

export type ImportCompleteDetail = {
  importedGameCount: number;
};

export function notifyImportComplete(detail: ImportCompleteDetail): void {
  window.dispatchEvent(
    new CustomEvent<ImportCompleteDetail>(IMPORT_COMPLETE_EVENT, { detail }),
  );
}

export function useImportComplete(
  handler: (detail: ImportCompleteDetail) => void,
): void {
  useEffect(() => {
    const listener = (event: Event) => {
      handler((event as CustomEvent<ImportCompleteDetail>).detail);
    };

    window.addEventListener(IMPORT_COMPLETE_EVENT, listener);
    return () => window.removeEventListener(IMPORT_COMPLETE_EVENT, listener);
  }, [handler]);
}
